window.addEventListener("DOMContentLoaded", (event) => {
  let state = {
    searchFormIsOpen: false,
  };

  const elements = {
    searchButton: document.querySelector("[data-search-button]"),
    searchForm: document.querySelector("[data-search-form]"),
    searchFormInput: document.querySelector("#q"),
    accordion: document.querySelectorAll("[data-accordion-trigger]"),
    subNavBlock: document.querySelectorAll("[data-accordion-block]"),
    icons: document.querySelectorAll(".accordion--icon"),
    wrapper: document.querySelector("#wrapper"),
    beforeAfterResize: document.querySelector("[data-before-after-resize]"),
    beforeAfterHandle: document.querySelector("[data-before-after-handle]"),
    beforeAfterWrapper: document.querySelector("[data-before-after-wrapper]"),
    beforeAfterContainer: document.querySelector(".before-after"),
    colorExpandSelector: document.querySelector("[data-color-expand]"),
    colorSwatchMore: document.querySelectorAll(".color-options--show-more"),
    colorSwatchLess: document.querySelectorAll(".color-options--show-less"),
    colorSwatchVariantSelector: document.querySelectorAll("[data-variant-selector]"),
    readmoreButtons: document.querySelectorAll(".expand-item-link"),
    isProductPage: document.querySelector(".product-page") !== null,
    mobileSearchIcon: document.querySelector("#mobileSearchIcon")
  };

  elements.searchFormInput.addEventListener("focus", function(event) {
    event.stopImmediatePropagation()
  })

  elements.searchButton.addEventListener("click", function (event) {
    if (!elements.searchForm.classList.contains("active")) {
      elements.searchForm.classList.add("active");
      elements.searchButton.classList.add("v-hide");
      state.searchFormIsOpen = true;
      window.setTimeout(() => elements.searchFormInput.focus(), 100);
      event.stopPropagation();
    }
  });

  elements.wrapper.addEventListener("click", function (event) {
    if (state.searchFormIsOpen && event.target != elements.searchFormInput) {
      elements.searchForm.classList.remove("active");
      elements.searchButton.classList.remove("v-hide");
    }
  });

  elements.accordion.forEach((accordion) => {
    accordion.addEventListener("click", function (event) {
      let hasOpenAccordion = false;
      elements.accordion.forEach((selectedAccordion) => {
        selectedAccordion === event.target
          ? selectedAccordion.classList.toggle("active")
          : selectedAccordion.classList.remove("active");
        if (selectedAccordion.classList.contains("active")) {
          hasOpenAccordion = true;
        }
      });
      elements.icons.forEach((icon) =>
        !hasOpenAccordion ? icon.classList.remove("active") : icon.classList.add("active")
      );
    });
  });

  // Language + Country Select
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector("button"),
        panel: this.querySelector("ul"),
      };
      this.elements.button.addEventListener("click", this.openSelector.bind(this));
      this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));
      this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

      this.querySelectorAll("a").forEach((item) =>
        item.addEventListener("click", this.onItemClick.bind(this))
      );
    }

    hidePanel() {
      this.elements.button.setAttribute("aria-expanded", "false");
      this.elements.panel.setAttribute("hidden", true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== "ESCAPE") return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      if (!this.event.classList.contains("external-link")) {
        event.preventDefault();
        const form = this.querySelector("form");
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute("hidden");
      this.elements.button.setAttribute(
        "aria-expanded",
        (this.elements.button.getAttribute("aria-expanded") === "false").toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define("localization-form", LocalizationForm);

  if (typeof elements.colorExpandSelector !== "undefined" &&
      elements.colorExpandSelector !== null &&
      elements.isProductPage
  ) {

    elements.colorSwatchMore.forEach((element) => {
      const id = element.dataset.id;
      const dots = document.querySelectorAll(`[data-product-id="${id}"] [data-dot-selector]`);
      element.addEventListener("click", function () {
        dots.forEach((dot) => {
          dot.classList.remove("hidden");
          element.classList.add("hidden");
        });
      });
    });

    elements.colorSwatchLess.forEach((element) => {
      const id = element.dataset.id;
      const dots = document.querySelectorAll(`[data-product-id="${id}"] [data-dot-selector]`);
      element.addEventListener("click", function () {
        dots.forEach((dot) => {
          dot.dataset.expand == "true"
            ? dot.classList.add("hidden")
            : dot.classList.remove("hidden");
          element.classList.add("hidden");
        });
      });
    });

    // function disabled to increase performance
    // to switch between products enable and make sure all "image-container" are rendered

    /*
    elements.colorSwatchVariantSelector.forEach((colorSwatch) => {
      colorSwatch.addEventListener("click", function () {
        const productId = colorSwatch.dataset.productSelector;
        const variantId = colorSwatch.dataset.variantSelector;
        const variantImageContainer = document.querySelector(`[data-variant-id="${variantId}"]`);
        const imageContainers = document.querySelectorAll(
          `[data-product-id="${productId}"] .image-container`
        );
        imageContainers.forEach((imageSet) => {
          imageSet.classList.remove("selected");
        });
        variantImageContainer.classList.add("selected");
      });
    });

    */
  }
  // Before after drag

  if (typeof elements.beforeAfterResize !== "undefined" && elements.beforeAfterResize !== null) {
    const element = elements.beforeAfterResize;
    const handle = elements.beforeAfterHandle;
    const wrapper = elements.beforeAfterWrapper;

    handle.addEventListener("pointerdown", (e) => {
      handle.setPointerCapture(e.pointerId);

      if (typeof elements.readmoreButtons !== "undefined" && elements.readmoreButtons !== null) {
        elements.readmoreButtons.forEach((button) => {
          let id = button.dataset.blockId;
          let parent = document.querySelector(`.c-accordion__panel--${id} .expand-item`);
          button.addEventListener("click", () => {
            button.parentElement.classList.add("expand");
            button.style.display = "none";
          });
        });
        handle.addEventListener("pointermove", resize);
        handle.addEventListener(
          "pointerup",
          () => {
            handle.removeEventListener("pointermove", resize);
          },
          { once: true }
        );
      }
    });

    function resize(e) {
      let pageWidth = elements.beforeAfterContainer.offsetWidth;
      let propWidth = (e.pageX / pageWidth) * wrapper.offsetWidth;
      let widthValue = `${(100 / wrapper.offsetWidth) * propWidth}%`;
      element.style.width = widthValue;
      handle.style.left = widthValue;
    }
  }

  if (typeof elements.readmoreButtons !== "undefined" && elements.readmoreButtons !== null) {
    elements.readmoreButtons.forEach((button) => {
      let id = button.dataset.blockId;
      let parent = document.querySelector(`.c-accordion__panel--${id} .expand-item`);
      button.addEventListener("click", () => {
        button.parentElement.classList.add("expand");
        button.style.display = "none";
      });
    });
  }

  if (elements.mobileSearchIcon) {
    window.addEventListener("scroll", function () {
      if (window.scrollY >= 30) {
        elements.mobileSearchIcon.classList.add('sticky--active');
        elements.searchForm.classList.add('sticky--active');
      } else {
        elements.mobileSearchIcon.classList.remove('sticky--active');
        elements.searchForm.classList.remove('sticky--active');
      }
    });
  }
});

document.querySelector(".mobile-menu__cart-icon")?.addEventListener("click", () => {
  Rebuy.SmartCart.show();
});
document.querySelectorAll(".btn.js-ajax-submit").forEach((item) =>
  item.addEventListener("click", (event) => {
    event.preventDefault();
    Rebuy.SmartCart.show();
  })
);

/* Back to Top Button */
const backToTopButton = document.querySelector("#back-to-top");

if (backToTopButton) {
  window.addEventListener("scroll", function () {
    if (window.scrollY > window.innerHeight) {
      backToTopButton.style.display = "block";
    } else {
      backToTopButton.style.display = "none";
    }
  });

  backToTopButton.addEventListener("click", (event) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  });
}

// Hero Banner Video
const imageElement = document.getElementById("hero-banner-image");
const iframeElement = document.querySelector(".home-header-video__wrapper");
const iframe = document.querySelector(".home-header-video__wrapper iframe");
const closeButton = document.querySelector(".close-button");

if (iframeElement) {
  imageElement.addEventListener("click", function () {
    iframeElement.style.top = "0";
    animateSlideDown();
    setTimeout(function () {
      closeButton.style.display = "block";
    }, 600);
  });
}

closeButton.addEventListener("click", function () {
  animateSlideUp();
  closeButton.style.display = "none";
});

function animateSlideDown() {
  const animationDuration = 1200;
  const fps = 60;
  const startPosition = -125;
  const endPosition = 0;
  const frameIncrement = (endPosition - startPosition) / (animationDuration / (1000 / fps));

  if (iframe && iframe.dataset.src) {
    iframe.src = iframe.dataset.src;
  }

  let currentPosition = startPosition;

  const animate = () => {
    currentPosition += frameIncrement;
    iframeElement.style.top = currentPosition + "vh";

    if (currentPosition < endPosition) {
      requestAnimationFrame(animate);
    } else {
      iframeElement.style.top = endPosition + "vh";
    }
  };

  animate();
  playVideo();
}

function animateSlideUp() {
  const animationDuration = 500;
  const fps = 60;

  const startPosition = 0;
  const endPosition = -125;
  const frameIncrement = (endPosition - startPosition) / (animationDuration / (1000 / fps));

  let currentPosition = startPosition;

  const animate = () => {
    currentPosition += frameIncrement;
    iframeElement.style.top = currentPosition + "vh";

    if (currentPosition > endPosition) {
      requestAnimationFrame(animate);
    } else {
      iframeElement.style.top = endPosition + "vh";
    }
  };

  animate();
  pauseVideo();
}

let player;

function onYouTubePlayerAPIReady() {
  player = new YT.Player("player", {
    events: {
      onReady: onPlayerReady,
    },
  });
}

function onPlayerReady(event) {
  event.target.console.log("ready");
}

function playVideo() {
  if (player) {
    player.playVideo();
    console.log("playing");
  }
}

function pauseVideo() {
  if (player) {
    player.pauseVideo();
    console.log("paused");
  }
  iframe.dataset.src = iframe.src;
  iframe.src = "";
}
